export const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleResponse = async (response) => {
  if (response.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    window.location.href = '/authentiate';
  }


  if (response.status === 204) { // Handle DELETE responses
    return null;
  }

  const data = response.status !== 204 ? await response.json() : null;

  if (!response.ok) {
    // Create an error object with the response data
    const error = new Error('API Error');
    error.response = {
      status: response.status,
      data: data
    };
    throw error;
  }

  return data;
};

export const authenticationClient = {
  post: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      // Create an error object with the response data
      const error = new Error('API Error');
      error.response = {
        status: response.status,
        data: data
      };
      throw error;
    }

    
    return response.json();
  },

}

export const client = {
  get: async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        ...getAuthHeader(),
      }
    });
    return handleResponse(response);
  },

  post: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  put: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  delete: async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        ...getAuthHeader(),
      }
    });
    return handleResponse(response);
  }
};

